import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Component, Injector, HostListener, Input, NgModule, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentPortal, PortalInjector, PortalModule } from '@angular/cdk/portal';
import { Subject } from 'rxjs';
import { DateTime, LocalizationModule, PopupModule } from '@wke/ucc-angular-alt-common';
import { IconModule } from '@wke/ucc-icons';
import { BadgeModule } from '@wke/ucc-angular-alt-drawing';

/**
 * Servicio de notificaciones de la aplicación
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@wke/ucc-icons';
import * as ɵngcc3 from '@angular/cdk/portal';
import * as ɵngcc4 from '@wke/ucc-angular-alt-common';

function NotificationItemComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r2.descriptionId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.notification.textContent, " ");
} }
function NotificationItemComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 13);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r3.descriptionId)("innerHTML", ctx_r3.notification.HTMLContent, ɵngcc0.ɵɵsanitizeHtml);
} }
function NotificationItemComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementContainer(1, 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r4.descriptionId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx_r4.notificationComponentContent);
} }
function NotificationItemComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "span", 16);
    ɵngcc0.ɵɵlistener("click", function NotificationItemComponent_div_0_div_7_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.notification.actionClick(ctx_r7.notification); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r5.actionId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.notification.actionLabel, " ");
} }
function NotificationItemComponent_div_0_ucc_icon_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ucc-icon", 17);
    ɵngcc0.ɵɵlistener("mouseup", function NotificationItemComponent_div_0_ucc_icon_11_Template_ucc_icon_mouseup_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onDeleteNotification(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r6.deleteId);
} }
const _c0 = function (a0) { return { "notificationNotReaded": a0 }; };
function NotificationItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵlistener("click", function NotificationItemComponent_div_0_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onOpenNotification(); });
    ɵngcc0.ɵɵelement(2, "ucc-icon", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵtemplate(4, NotificationItemComponent_div_0_div_4_Template, 2, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(5, NotificationItemComponent_div_0_div_5_Template, 1, 2, "div", 7);
    ɵngcc0.ɵɵtemplate(6, NotificationItemComponent_div_0_div_6_Template, 2, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(7, NotificationItemComponent_div_0_div_7_Template, 3, 2, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 10);
    ɵngcc0.ɵɵtemplate(11, NotificationItemComponent_div_0_ucc_icon_11_Template, 1, 1, "ucc-icon", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.notification.id)("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c0, !ctx_r0.notification.isReaded));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", ctx_r0.iconId)("key", ctx_r0.notification.icon)("iconClass", ctx_r0.notification.iconClass ? ctx_r0.notification.iconClass : "greyIcon");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.textContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.HTMLContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.componentContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notification.actionClick);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r0.dateId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getDate(ctx_r0.notification.date));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isMouseOver);
} }
function NotificationItemComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 20);
    ɵngcc0.ɵɵelementStart(5, "span", 21);
    ɵngcc0.ɵɵlistener("mouseup", function NotificationItemComponent_div_1_Template_span_mouseup_5_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onRevertNotificationDeleted(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r1.notification.id)("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c0, !ctx_r1.notification.isReaded));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r1.deletedId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 6, "notification_deleted"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", ctx_r1.undoId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 8, "undo"), " ");
} }
function NotificationsComponent_ngwk_popup_0_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "ngwk-notification-item", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("notification", notification_r5);
    ɵngcc0.ɵɵattribute("type", ctx_r4.getType(notification_r5));
} }
function NotificationsComponent_ngwk_popup_0_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, NotificationsComponent_ngwk_popup_0_div_11_div_1_Template, 2, 2, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.notifications);
} }
function NotificationsComponent_ngwk_popup_0_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelement(2, "ucc-icon", 16);
    ɵngcc0.ɵɵelementStart(3, "span", 17);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 1, "no_notifications"));
} }
function NotificationsComponent_ngwk_popup_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-popup", 1);
    ɵngcc0.ɵɵlistener("close", function NotificationsComponent_ngwk_popup_0_Template_ngwk_popup_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onClose(); })("open", function NotificationsComponent_ngwk_popup_0_Template_ngwk_popup_open_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onOpen(); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 5, 6);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵlistener("click", function NotificationsComponent_ngwk_popup_0_Template_div_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onDeleteAllNotifications(); });
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, NotificationsComponent_ngwk_popup_0_div_11_Template, 2, 1, "div", 8);
    ɵngcc0.ɵɵtemplate(12, NotificationsComponent_ngwk_popup_0_div_12_Template, 6, 3, "div", 9);
    ɵngcc0.ɵɵelement(13, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", ctx_r0.anchor)("margin", ctx_r0.margin)("anchorAlign", ctx_r0.anchorAlign)("popupAlign", ctx_r0.popupAlign)("popupClass", ctx_r0.popupClass);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 9, "notifications"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 11, "delete_all"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notifications.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.notifications.length === 0);
} }
const _c1 = function (a0) { return { "width": a0 }; };
class NotificationsService {
    constructor() {
        this._notifications = [];
        this._openNotification$ = new Subject();
        this._viewAllNotifications$ = new Subject();
        this._deleteNotifications$ = new Subject();
        this._deleteAllNotifications$ = new Subject();
        this._markAllNotificationsAsRead$ = new Subject();
        this._isPopupOpened = false;
    }
    /**
     * Método que sirve para abrir una notificación. Se envia un evento allá donde se haya suscrito con el método 'openNotification$'
     *
     * @param notification Notificación emitida
     */
    openNotification(notification) {
        this._openNotification$.next(notification);
    }
    /**
     * Método para suscribirse al evento de abrir una notificación. Devuelve la información de la notificación.
     */
    get openNotification$() {
        return this._openNotification$.asObservable();
    }
    /** @ignore */
    viewAllNotifications() {
        this._viewAllNotifications$.next();
    }
    /** @ignore */
    get viewAllNotifications$() {
        return this._viewAllNotifications$.asObservable();
    }
    /** @ignore */
    markAllNotificationsAsRead() {
        this._markAllNotificationsAsRead$.next();
    }
    /** @ignore */
    get markAllNotificationsAsRead$() {
        return this._markAllNotificationsAsRead$.asObservable();
    }
    /**
     * Método que sirve para notificar que se han borrado todas las notificaciones listadas actualmente.
     */
    deleteAllNotifications() {
        this._deleteAllNotifications$.next();
    }
    /**
     * Método para suscribirse al evento de borrar notificaciones, informando al usuario de cuando se ha producido
     */
    get deleteAllNotifications$() {
        return this._deleteAllNotifications$.asObservable();
    }
    /**
     * Método que sirve para notificar que se han borrado notificaciones.
     */
    deleteNotifications(notificationsToDelete) {
        this._deleteNotifications$.next(notificationsToDelete);
    }
    /**
     * Método para suscribirse al evento de borrar todas las notificaciones, informando al usuario de cuando se ha producido
     */
    get deleteNotifications$() {
        return this._deleteNotifications$.asObservable();
    }
    /** @ignore */
    markAllNewNotifications() {
        for (let notification of this._notifications) {
            notification.isNew = false;
        }
    }
    /**
     * Método para incluir las notificaciones que se mostrarán en el componente de NotificationsComponent
     *
     * @param newNotifications Notificaciones a incluir en el componente
     */
    addNotifications(newNotifications) {
        if (!this._isPopupOpened) {
            for (let notification of newNotifications) {
                notification.isNew = true;
            }
        }
        this._notifications.unshift(...newNotifications);
    }
    /**
     * Método para actualizar las notificaciones existentes en la lista, pasando las que ya estaban. Se debe asegurar que cada notificacion tiene una id identificativa para poder actualizarse correctamente.
     *
     * @param updatedNotifications Notificaciones a actualizar en el componente
     */
    updateNotifications(updatedNotifications) {
        this._notifications = this._notifications.map((currentNotification) => {
            let notificationToUpdate = updatedNotifications.find((updatedNotification) => updatedNotification.id === currentNotification.id);
            return notificationToUpdate ? Object.assign(Object.assign({}, currentNotification), notificationToUpdate) : currentNotification;
        });
    }
    /**
     * Método para borrar la notificacion existente en la lista del componente.
     *
     * @param notificationToDelete Notificacion a borrar en el componente
     */
    removeNotification(notificationToDelete) {
        this._notifications = this._notifications.filter((notification) => notification !== notificationToDelete);
    }
    /**
     * Método para borrar las notificaciones existentes en la lista del componente.
     *
     * @param notificationsToDelete Notificaciones a borrar en el componente
     */
    removeNotifications(notificationsToDelete) {
        this._notifications = this._notifications.filter((notification) => !notificationsToDelete.includes(notification));
    }
    /**
     * Método para vaciar toda la lista de notificaciones del componente
     */
    clearNotifications() {
        this._notifications = [];
    }
    /**
     * Método para obtener toda la lista de notificaciones del componente
     */
    get notifications() {
        return this._notifications;
    }
    /**
     * Método para inicializar la lista de notificaciones del componente, o bien poner una lista diferente
     */
    set notifications(notifications) {
        this._notifications = notifications;
    }
    /** @ignore */
    get isPopupOpened() {
        return this._isPopupOpened;
    }
    /** @ignore */
    set isPopupOpened(value) {
        this._isPopupOpened = value;
    }
    /** @ignore */
    get totalNewNotifications() {
        return this._notifications.filter((notification) => notification.isNew).length;
    }
}
NotificationsService.ɵfac = function NotificationsService_Factory(t) { return new (t || NotificationsService)(); };
/** @nocollapse */ NotificationsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NotificationsService_Factory() { return new NotificationsService(); }, token: NotificationsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/** Parámetros inyectables en las notificaciones que sean de tipo Component */
const NOTIFICATION_PARAMS = new InjectionToken('NOTIFICATION_PARAMS');

/**
 * Este componente se utiliza para la declaración de una notificación, la cual puede tener un contenido de texto string,
 * texto HTML o un componente customizado. Recibe un input 'notification' del tipo [INgwkNotificationItem]{@link INgwkNotificationItem}
 *
 * @example
 * <ngwk-notification-item [notification]="notification"></ngwk-notification-item>
 *
 */
class NotificationItemComponent {
    //#endregion
    /**@ignore */
    constructor(_injector, _notificationsService) {
        this._injector = _injector;
        this._notificationsService = _notificationsService;
        //#region Privates
        this._notification = null;
        this._notificationComponentContent = null;
        this._isMouseOver = false;
    }
    //#region Hooks
    /** @ignore */
    ngOnInit() {
        if (this._notification.componentContent) {
            const notificationContentParams = this._notification.componentContentParams;
            this._notificationComponentContent = new ComponentPortal(this._notification.componentContent, null, this.getInjector(notificationContentParams));
        }
    }
    //#endregion
    //#region Host Listeners
    /** @ignore */
    onMouseOver() {
        this._isMouseOver = true;
    }
    /** @ignore */
    onMouseOut() {
        this._isMouseOver = false;
    }
    //#endregion
    //#region Private Methods
    getInjector(notificationContentParams) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(NOTIFICATION_PARAMS, notificationContentParams);
        return new PortalInjector(this._injector, injectionTokens);
    }
    //#endregion
    //#region Public Methods
    /** @ignore */
    getDate(date) {
        return DateTime.timeAgoFormat(date);
    }
    /** @ignore */
    onDeleteNotification() {
        this.notification.isDeleted = true;
    }
    /** @ignore */
    onRevertNotificationDeleted() {
        this.notification.isDeleted = false;
    }
    /** @ignore */
    onOpenNotification() {
        this.notification.isNew = false;
        this._notificationsService.updateNotifications([this.notification]);
        this._notificationsService.openNotification(this.notification);
    }
    //#endregion
    //#region Getters & Setters
    /**
     * Permite obtener los parámetros de la notificación del componente
     */
    get notification() {
        return this._notification;
    }
    /**
     * Permite definir los parámetros de la notificación del componente
     *
     * @param value Los parámetros de la notificación del componente
     */
    set notification(value) {
        this._notification = value;
    }
    /** @ignore */
    get notificationComponentContent() {
        return this._notificationComponentContent;
    }
    /** @ignore */
    get isMouseOver() {
        return this._isMouseOver;
    }
    /** @ignore */
    get iconId() {
        return 'notification-icon';
    }
    /** @ignore */
    get descriptionId() {
        return 'notification-description';
    }
    /** @ignore */
    get actionId() {
        return 'notification-action';
    }
    /** @ignore */
    get dateId() {
        return 'notification-date';
    }
    /** @ignore */
    get deleteId() {
        return 'notification-delete';
    }
    /** @ignore */
    get deletedId() {
        return 'notification-deleted';
    }
    /** @ignore */
    get undoId() {
        return 'notification-undo';
    }
}
NotificationItemComponent.ɵfac = function NotificationItemComponent_Factory(t) { return new (t || NotificationItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(NotificationsService)); };
NotificationItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationItemComponent, selectors: [["ngwk-notification-item"]], hostBindings: function NotificationItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function NotificationItemComponent_mouseenter_HostBindingHandler() { return ctx.onMouseOver(); })("mouseleave", function NotificationItemComponent_mouseleave_HostBindingHandler() { return ctx.onMouseOut(); });
    } }, inputs: { notification: "notification" }, decls: 2, vars: 2, consts: [["class", "horizontalLayout notificationContainer", 3, "id", "ngClass", 4, "ngIf"], ["class", "horizontalLayout notificationDeletedContainer", 3, "id", "ngClass", 4, "ngIf"], [1, "horizontalLayout", "notificationContainer", 3, "id", "ngClass"], [1, "colAvailable", "horizontalLayout", 3, "click"], [1, "colAuto", "alignMiddle", "notificationIcon", 3, "id", "key", "iconClass"], ["id", "notificationContent", 1, "colAvailable", "verticalLayout", "alignHorizontalMiddle"], [3, "id", 4, "ngIf"], [3, "id", "innerHTML", 4, "ngIf"], ["class", "notificationAction", 3, "id", 4, "ngIf"], [1, "colAuto", "alignMiddle", "notificationDate", 3, "id"], [1, "colAuto", "alignMiddle", "notificationDelete"], ["class", "notificationDeleteIcon", "key", "trash", 3, "id", "mouseup", 4, "ngIf"], [3, "id"], [3, "id", "innerHTML"], [3, "cdkPortalOutlet"], [1, "notificationAction", 3, "id"], [3, "click"], ["key", "trash", 1, "notificationDeleteIcon", 3, "id", "mouseup"], [1, "horizontalLayout", "notificationDeletedContainer", 3, "id", "ngClass"], [1, "alignMiddle", 3, "id"], [1, "alignMiddle", "notificationDeletedAction", 3, "id"], [3, "mouseup"]], template: function NotificationItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NotificationItemComponent_div_0_Template, 12, 14, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NotificationItemComponent_div_1_Template, 8, 12, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.notification.isDeleted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.notification.isDeleted);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc2.IconComponent, ɵngcc3.CdkPortalOutlet], pipes: [ɵngcc4.LocalePipe], styles: ["[_nghost-%COMP%]     .notificationContainer{font-size:12px;border-top:1px solid #EDEDED;border-bottom:1px solid #EDEDED;width:365px;min-height:50px;padding:5px 0;cursor:pointer}[_nghost-%COMP%]     .notificationContainer .notificationIcon{width:50px}[_nghost-%COMP%]     .notificationContainer .notificationDate{width:80px;color:gray;font-size:10px}[_nghost-%COMP%]     .notificationContainer .notificationDelete{width:40px;padding-right:10px;padding-left:10px;cursor:default!important}[_nghost-%COMP%]     .notificationContainer .notificationDelete .notificationDeleteIcon{color:#666;cursor:pointer!important}[_nghost-%COMP%]     .notificationContainer .notificationAction{color:#0081c6;font-size:12px;cursor:pointer}[_nghost-%COMP%]     .notificationDeletedContainer{border-top:1px solid #EDEDED;border-bottom:1px solid #EDEDED;width:365px;min-height:50px;padding-left:50px;font-size:12px;cursor:default}[_nghost-%COMP%]     .notificationDeletedContainer .notificationDeletedAction{margin-left:5px;color:#0081c6;cursor:pointer}[_nghost-%COMP%]     .notificationNotReaded{background-color:#ebfaff!important}"] });
/** @nocollapse */
NotificationItemComponent.ctorParameters = () => [
    { type: Injector },
    { type: NotificationsService }
];
NotificationItemComponent.propDecorators = {
    onMouseOver: [{ type: HostListener, args: ['mouseenter',] }],
    onMouseOut: [{ type: HostListener, args: ['mouseleave',] }],
    notification: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationItemComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-notification-item",
                template: "<div *ngIf=\"!notification.isDeleted\" [id]=\"notification.id\" class=\"horizontalLayout notificationContainer\" [ngClass]=\"{'notificationNotReaded': !notification.isReaded}\">\r\n    <div class=\"colAvailable horizontalLayout\" (click)=\"onOpenNotification()\">\r\n        <ucc-icon \r\n            [id]=\"iconId\"\r\n            class=\"colAuto alignMiddle notificationIcon\"\r\n            [key]=\"notification.icon\" \r\n            [iconClass]=\"notification.iconClass ? notification.iconClass : 'greyIcon'\">\r\n        </ucc-icon>\r\n        <div class=\"colAvailable verticalLayout alignHorizontalMiddle\"  id=\"notificationContent\">\r\n            <div *ngIf=\"notification.textContent\" [id]=\"descriptionId\">\r\n                {{notification.textContent}}\r\n            </div>\r\n            <div *ngIf=\"notification.HTMLContent\" [id]=\"descriptionId\" [innerHTML]=\"notification.HTMLContent\"></div>\r\n            <div *ngIf=\"notification.componentContent\" [id]=\"descriptionId\">\r\n                <ng-container [cdkPortalOutlet]=\"notificationComponentContent\"></ng-container>\r\n            </div>\r\n            <div *ngIf=\"notification.actionClick\" [id]=\"actionId\" class=\"notificationAction\">\r\n                <span (click)=\"notification.actionClick(notification)\">\r\n                    {{notification.actionLabel}}\r\n                </span>\r\n            </div>\r\n        </div>\r\n        <div [id]=\"dateId\" class=\"colAuto alignMiddle notificationDate\">{{getDate(notification.date)}}</div>\r\n    </div>\r\n    <div class=\"colAuto alignMiddle notificationDelete\">\r\n        <ucc-icon *ngIf=\"isMouseOver\" [id]=\"deleteId\" class=\"notificationDeleteIcon\" key=\"trash\" (mouseup)=\"onDeleteNotification()\"></ucc-icon>\r\n    </div>\r\n</div>\r\n<div *ngIf=\"notification.isDeleted\" [id]=\"notification.id\" class=\"horizontalLayout notificationDeletedContainer\" [ngClass]=\"{'notificationNotReaded': !notification.isReaded}\">\r\n    <div [id]=\"deletedId\" class=\"alignMiddle\">\r\n        {{ 'notification_deleted' | locale }}\r\n    </div>\r\n    <div [id]=\"undoId\" class=\"alignMiddle notificationDeletedAction\">\r\n        <span (mouseup)=\"onRevertNotificationDeleted()\">\r\n            {{ 'undo' | locale }}\r\n        </span>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep .notificationContainer{font-size:12px;border-top:1px solid #EDEDED;border-bottom:1px solid #EDEDED;width:365px;min-height:50px;padding:5px 0;cursor:pointer}:host ::ng-deep .notificationContainer .notificationIcon{width:50px}:host ::ng-deep .notificationContainer .notificationDate{width:80px;color:gray;font-size:10px}:host ::ng-deep .notificationContainer .notificationDelete{width:40px;padding-right:10px;padding-left:10px;cursor:default!important}:host ::ng-deep .notificationContainer .notificationDelete .notificationDeleteIcon{color:#666;cursor:pointer!important}:host ::ng-deep .notificationContainer .notificationAction{color:#0081c6;font-size:12px;cursor:pointer}:host ::ng-deep .notificationDeletedContainer{border-top:1px solid #EDEDED;border-bottom:1px solid #EDEDED;width:365px;min-height:50px;padding-left:50px;font-size:12px;cursor:default}:host ::ng-deep .notificationDeletedContainer .notificationDeletedAction{margin-left:5px;color:#0081c6;cursor:pointer}:host ::ng-deep .notificationNotReaded{background-color:#ebfaff!important}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: NotificationsService }]; }, { 
    //#endregion
    //#region Host Listeners
    /** @ignore */
    onMouseOver: [{
            type: HostListener,
            args: ['mouseenter']
        }], 
    /** @ignore */
    onMouseOut: [{
            type: HostListener,
            args: ['mouseleave']
        }], notification: [{
            type: Input
        }] }); })();

class NotificationItemModule {
}
NotificationItemModule.ɵfac = function NotificationItemModule_Factory(t) { return new (t || NotificationItemModule)(); };
NotificationItemModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NotificationItemModule });
NotificationItemModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PortalModule,
            IconModule,
            LocalizationModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationItemModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PortalModule,
                    IconModule,
                    LocalizationModule
                ],
                declarations: [
                    NotificationItemComponent
                ],
                exports: [
                    NotificationItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotificationItemModule, { declarations: function () { return [NotificationItemComponent]; }, imports: function () { return [CommonModule,
        PortalModule,
        IconModule,
        LocalizationModule]; }, exports: function () { return [NotificationItemComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un desplegable de notificaciones, el cual depende de otro elemento HTML a modo de anchor.
 *
 * @example
 * <ngwk-notifications
 *  [showNotifications]="showNotifications"
 *  [anchor]="anchor">
 * </ngwk-notifications>
 *
 */
class NotificationsComponent {
    //#endregion
    /** @ignore */
    constructor(_notificationsService) {
        this._notificationsService = _notificationsService;
        //#region Privates
        this._anchor = null;
        this._showNotifications = true;
        this._margin = { horizontal: 0, vertical: 0 };
        this._anchorAlign = { horizontal: "center", vertical: "bottom" };
        this._popupAlign = { horizontal: "center", vertical: "top" };
        this._popupClass = "menuPopupContainer";
    }
    //#region Private Methods
    onDeleteTaggedNotifications() {
        let notificationsToDelete = [];
        for (let notification of this.notifications) {
            if (notification.isDeleted) {
                notificationsToDelete.push(notification);
            }
        }
        if (notificationsToDelete.length > 0) {
            this._notificationsService.removeNotifications(notificationsToDelete);
            this.onDeleteNotifications(notificationsToDelete);
        }
    }
    //#endregion
    //#region Public Methods
    /** @ignore */
    onMarkAllNewNotifications() {
        this._notificationsService.markAllNewNotifications();
    }
    /** @ignore */
    onDeleteAllNotifications() {
        this._notificationsService.deleteAllNotifications();
    }
    /** @ignore */
    onDeleteNotifications(notificationsToDelete) {
        this._notificationsService.deleteNotifications(notificationsToDelete);
    }
    /** @ignore */
    onViewAllNotifications() {
        this._notificationsService.viewAllNotifications();
    }
    /** @ignore */
    onOpen() {
        this._notificationsService.isPopupOpened = true;
        this.onMarkAllNewNotifications();
    }
    /** @ignore */
    onClose() {
        this._notificationsService.isPopupOpened = false;
        this.onDeleteTaggedNotifications();
    }
    /** @ignore */
    getType(notification) {
        return notification.type ? notification.type : null;
    }
    //#endregion
    //#region Getters & Setters
    /**
     * Permite consultar si el recuadro de notificaciones está abierto o no
     */
    get showNotifications() {
        return this._showNotifications;
    }
    /**
     * Permite activar o desactivar la opción de mostrar el Popup de las notificaciones
     *
     * @param value Valor que activa o desactiva la opción de mostrar el Popup de las notificaciones
     */
    set showNotifications(value) {
        this._showNotifications = value;
    }
    /**
     * Permite obtener el anchor al cual estará anclado el Popup de las notificaciones
     */
    get anchor() {
        return this._anchor;
    }
    /**
     * Permite definir el anchor al cual estará anclado el Popup de las notificaciones
     *
     * @param value El anchor al cual estará anclado el Popup de las notificaciones
     */
    set anchor(value) {
        this._anchor = value;
    }
    /**
     * Permite obtener la clase decoradora principal del Popup de las notificaciones
     */
    get popupClass() {
        return this._popupClass;
    }
    /**
     * Permite definir la clase decoradora principal del Popup de las notificaciones
     *
     * @param value La clase decoradora principal del Popup de las notificaciones
     */
    set popupClass(value) {
        this._popupClass = value;
    }
    /**
     * Permite obtener el margen del Popup de las notificaciones. Este margen es de tipo [NgwkPopupMargin]{@link NgwkPopupMargin}
     */
    get margin() {
        return this._margin;
    }
    /**
     * Permite obtener el alineamiento respecto al anchor del Popup de las notificaciones. Este alineamiento es de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
     */
    get anchorAlign() {
        return this._anchorAlign;
    }
    /**
     * Permite obtener el alineamiento respecto al propio Popup de las notificaciones. Este alineamiento es de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
     */
    get popupAlign() {
        return this._popupAlign;
    }
    /**
     * Permite obtener las notificaciones a mostrar en el componente
     */
    get notifications() {
        return this._notificationsService.notifications;
    }
}
NotificationsComponent.ɵfac = function NotificationsComponent_Factory(t) { return new (t || NotificationsComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationsService)); };
NotificationsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationsComponent, selectors: [["ngwk-notifications"]], inputs: { showNotifications: "showNotifications", anchor: "anchor", popupClass: "popupClass" }, decls: 1, vars: 1, consts: [[3, "anchor", "margin", "anchorAlign", "popupAlign", "popupClass", "close", "open", 4, "ngIf"], [3, "anchor", "margin", "anchorAlign", "popupAlign", "popupClass", "close", "open"], [1, "notificationsContent"], [1, "horizontalLayout", "notificationsHeader"], [1, "colAvailable", "alignVerticalMiddle"], ["id", "notifications_title", 1, "notificationsTitle"], ["notificationsSpan", ""], ["id", "notifications-delete-all", 1, "colAuto", "alignVerticalMiddle", "deleteAllNotifications", 3, "click"], ["class", "verticalLayout notificationsContainer", 4, "ngIf"], ["class", "alignMiddle notificationsContainer", 4, "ngIf"], [1, "horizontalLayout", "notificationsFooter"], [1, "verticalLayout", "notificationsContainer"], [4, "ngFor", "ngForOf"], [3, "notification"], [1, "alignMiddle", "notificationsContainer"], [1, "noNotifications"], ["key", "bell", "iconClass", "noNotificationsIcon"], [1, "noNotificationsText"]], template: function NotificationsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NotificationsComponent_ngwk_popup_0_Template, 14, 13, "ngwk-popup", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNotifications);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.PopupComponent, ɵngcc1.NgForOf, NotificationItemComponent, ɵngcc2.IconComponent], pipes: [ɵngcc4.LocalePipe], styles: ["[_nghost-%COMP%]    {cursor:default}[_nghost-%COMP%]     .notificationsHeader{height:30px;border-bottom:1px solid #EDEDED}[_nghost-%COMP%]     .notificationsTitle{color:#000;font-size:13px;padding-left:9px}[_nghost-%COMP%]     .deleteAllNotifications{color:#0081c6;cursor:pointer;font-size:12px;padding-right:10px}[_nghost-%COMP%]     .notificationsContainer{width:100%;height:100%;min-width:365px!important;max-height:251px!important;min-height:150px!important;overflow:auto}[_nghost-%COMP%]     .notificationsFooter{height:5px;border-top:1px solid #EDEDED}[_nghost-%COMP%]     .notificationsSeeAll{color:#0081c6;cursor:pointer;font-size:12px;padding-right:10px}[_nghost-%COMP%]     .noNotifications{display:block;text-align:center}[_nghost-%COMP%]     .noNotifications .noNotificationsIcon i{margin-bottom:10px;font-size:60px;color:#bbb}[_nghost-%COMP%]     .noNotifications .noNotificationsText{color:#bbb}[_nghost-%COMP%]     .notificationsBadge{margin-left:5px;border-radius:25px;height:15px;min-height:10px;min-width:10px;max-width:42px;padding:0 5px;background-color:red}[_nghost-%COMP%]     .notificationsBadgeText{font-size:11px;color:#fff}"] });
/** @nocollapse */
NotificationsComponent.ctorParameters = () => [
    { type: NotificationsService }
];
NotificationsComponent.propDecorators = {
    showNotifications: [{ type: Input }],
    anchor: [{ type: Input }],
    popupClass: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationsComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-notifications",
                template: "<ngwk-popup\r\n  *ngIf=\"showNotifications\" \r\n  [anchor]=\"anchor\" \r\n  [margin]=\"margin\" \r\n  [anchorAlign]=\"anchorAlign\"\r\n  [popupAlign]=\"popupAlign\"\r\n  [popupClass]=\"popupClass\"\r\n  (close)=\"onClose()\"\r\n  (open)=\"onOpen()\">\r\n    <div class=\"notificationsContent\">\r\n      <div class=\"horizontalLayout notificationsHeader\">\r\n        <div class='colAvailable alignVerticalMiddle' >\r\n          <div id=\"notifications_title\" class=\"notificationsTitle\" #notificationsSpan>{{'notifications' | locale }}</div>\r\n        </div>\r\n        <div id=\"notifications-delete-all\" class='colAuto alignVerticalMiddle deleteAllNotifications' (click)=\"onDeleteAllNotifications()\">\r\n          {{'delete_all' | locale }}\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"notifications.length > 0\" class=\"verticalLayout notificationsContainer\">\r\n        <div *ngFor=\"let notification of notifications\">\r\n          <ngwk-notification-item [notification]=\"notification\" [attr.type]=\"getType(notification)\"></ngwk-notification-item>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"notifications.length === 0\" class=\"alignMiddle notificationsContainer\">\r\n        <div class=\"noNotifications\">\r\n          <ucc-icon key='bell' iconClass=\"noNotificationsIcon\"></ucc-icon>\r\n          <span class=\"noNotificationsText\">{{'no_notifications' | locale }}</span>\r\n        </div>\r\n      </div>\r\n      <div class=\"horizontalLayout notificationsFooter\">\r\n        <!-- <div class='colAvailable alignVerticalMiddle'></div>\r\n        <div class='colAuto alignVerticalMiddle notificationsSeeAll' (click)=\"onViewAllNotifications()\">\r\n          {{'see_all' | locale }}\r\n        </div> -->\r\n      </div>\r\n    </div>\r\n</ngwk-popup>",
                styles: [":host ::ng-deep{cursor:default}:host ::ng-deep .notificationsHeader{height:30px;border-bottom:1px solid #EDEDED}:host ::ng-deep .notificationsTitle{color:#000;font-size:13px;padding-left:9px}:host ::ng-deep .deleteAllNotifications{color:#0081c6;cursor:pointer;font-size:12px;padding-right:10px}:host ::ng-deep .notificationsContainer{width:100%;height:100%;min-width:365px!important;max-height:251px!important;min-height:150px!important;overflow:auto}:host ::ng-deep .notificationsFooter{height:5px;border-top:1px solid #EDEDED}:host ::ng-deep .notificationsSeeAll{color:#0081c6;cursor:pointer;font-size:12px;padding-right:10px}:host ::ng-deep .noNotifications{display:block;text-align:center}:host ::ng-deep .noNotifications .noNotificationsIcon i{margin-bottom:10px;font-size:60px;color:#bbb}:host ::ng-deep .noNotifications .noNotificationsText{color:#bbb}:host ::ng-deep .notificationsBadge{margin-left:5px;border-radius:25px;height:15px;min-height:10px;min-width:10px;max-width:42px;padding:0 5px;background-color:red}:host ::ng-deep .notificationsBadgeText{font-size:11px;color:#fff}\n"]
            }]
    }], function () { return [{ type: NotificationsService }]; }, { showNotifications: [{
            type: Input
        }], anchor: [{
            type: Input
        }], popupClass: [{
            type: Input
        }] }); })();

/**
 * Este componente se utiliza para la declaración de una notificación de tipo progress. Debe recibir unos parámetros de tipo
 * [INotificationItemCatalogParams]{@link INotificationItemCatalogParams} que contienen un data de tipo
 * [INotificationItemProgressParams]{@link INotificationItemProgressParams}
 */
class NotificationItemProgressComponent {
    /** @ignore */
    constructor(_notificationComponentParams) {
        this._notificationComponentParams = _notificationComponentParams;
        this._notificationItemProgressParams = { text: '', percentage: 30 };
        this._notificationItemProgressParams = this._notificationComponentParams.data;
    }
    /** @ignore */
    getLeftProgress() {
        return (this._notificationItemProgressParams.percentage * 100) + 'px';
    }
    /** @ignore */
    getRightProgress() {
        return (100 - (this._notificationItemProgressParams.percentage * 100)) + 'px';
    }
    /** @ignore */
    get percentage() {
        return (this._notificationItemProgressParams.percentage * 100) + '%';
    }
    /** @ignore */
    get text() {
        return this._notificationItemProgressParams.text;
    }
}
NotificationItemProgressComponent.ɵfac = function NotificationItemProgressComponent_Factory(t) { return new (t || NotificationItemProgressComponent)(ɵngcc0.ɵɵdirectiveInject(NOTIFICATION_PARAMS)); };
NotificationItemProgressComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationItemProgressComponent, selectors: [["ng-component"]], decls: 8, vars: 8, consts: [[1, "verticalLayout", "alignMiddle"], [1, "notificationProgressText"], [1, "horizontalLayout", "alignMiddle"], [1, "notificationProgressPercentage"], [1, "leftSideProgressBar", 3, "ngStyle"], [1, "rightSideProgressBar", 3, "ngStyle"]], template: function NotificationItemProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.percentage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx.getLeftProgress()));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c1, ctx.getRightProgress()));
    } }, directives: [ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]     .notificationProgressContainer{height:100%}[_nghost-%COMP%]     .notificationProgressPercentage{margin-right:10px;color:gray}[_nghost-%COMP%]     .notificationProgressText{width:100%;text-align:left}[_nghost-%COMP%]     .leftSideProgressBar{height:5px;background-color:#67b700;border-top-left-radius:5px;border-bottom-left-radius:5px}[_nghost-%COMP%]     .rightSideProgressBar{height:5px;background-color:#eaeaea;border-top-right-radius:5px;border-bottom-right-radius:5px}"] });
/** @nocollapse */
NotificationItemProgressComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NOTIFICATION_PARAMS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationItemProgressComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"verticalLayout alignMiddle\">\r\n    <div class=\"notificationProgressText\">{{text}}</div>\r\n    <div class=\"horizontalLayout alignMiddle\">\r\n        <div class=\"notificationProgressPercentage\">{{percentage}}</div>\r\n        <div class=\"leftSideProgressBar\" [ngStyle]=\"{ 'width': getLeftProgress() }\"></div>\r\n        <div class=\"rightSideProgressBar\" [ngStyle]=\"{ 'width': getRightProgress() }\"></div>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep .notificationProgressContainer{height:100%}:host ::ng-deep .notificationProgressPercentage{margin-right:10px;color:gray}:host ::ng-deep .notificationProgressText{width:100%;text-align:left}:host ::ng-deep .leftSideProgressBar{height:5px;background-color:#67b700;border-top-left-radius:5px;border-bottom-left-radius:5px}:host ::ng-deep .rightSideProgressBar{height:5px;background-color:#eaeaea;border-top-right-radius:5px;border-bottom-right-radius:5px}\n"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NOTIFICATION_PARAMS]
            }] }]; }, null); })();

/**
 * Este componente se utiliza para la declaración de una notificación de tipo question
 */
class NotificationItemQuestionComponent {
}
NotificationItemQuestionComponent.ɵfac = function NotificationItemQuestionComponent_Factory(t) { return new (t || NotificationItemQuestionComponent)(); };
NotificationItemQuestionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationItemQuestionComponent, selectors: [["ng-component"]], decls: 0, vars: 0, template: function NotificationItemQuestionComponent_Template(rf, ctx) { }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationItemQuestionComponent, [{
        type: Component,
        args: [{
                template: "",
                styles: [""]
            }]
    }], null, null); })();

class NotificationsModule {
}
NotificationsModule.ɵfac = function NotificationsModule_Factory(t) { return new (t || NotificationsModule)(); };
NotificationsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NotificationsModule });
NotificationsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PopupModule,
            IconModule,
            BadgeModule,
            LocalizationModule,
            NotificationItemModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PopupModule,
                    IconModule,
                    BadgeModule,
                    LocalizationModule,
                    NotificationItemModule
                ],
                declarations: [
                    NotificationsComponent,
                    NotificationItemProgressComponent,
                    NotificationItemQuestionComponent
                ],
                exports: [
                    NotificationsComponent,
                    NotificationItemProgressComponent,
                    NotificationItemQuestionComponent
                ],
                entryComponents: [
                    NotificationsComponent,
                    NotificationItemProgressComponent,
                    NotificationItemQuestionComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotificationsModule, { declarations: function () { return [NotificationsComponent, NotificationItemProgressComponent, NotificationItemQuestionComponent]; }, imports: function () { return [CommonModule,
        PopupModule,
        IconModule,
        BadgeModule,
        LocalizationModule, NotificationItemModule]; }, exports: function () { return [NotificationsComponent, NotificationItemProgressComponent, NotificationItemQuestionComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NOTIFICATION_PARAMS, NotificationItemProgressComponent, NotificationItemQuestionComponent, NotificationsComponent, NotificationsModule, NotificationsService, NotificationItemModule as ɵa, NotificationItemComponent as ɵb };

